import React, { useState } from "react";
import { InputGroup, Button } from "../../../UI";
import ellipse from "../../../assets/Ellipse2.svg";
import Container from "./styles";
import { contactUs } from "../../../store/actions";
import { formValidator } from "../../../helpers";
import {useDispatch} from 'react-redux'
import { useNavigate } from 'react-router-dom'

const GetInTouch = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const storedState = sessionStorage.getItem("authState");
  const [loading, setLoading] = useState(false);
  const [formData, setFormState] = useState(() =>
    storedState ? JSON.parse(storedState) : {}
  );

  const handleInput = ({ target }) => {
    setFormState((s) => ({
      ...s,
      [target.name]: target.value
    }));
  };

  const handleSubmit = async () => {
    if (
      formValidator(document.forms["contact"].getElementsByTagName("input"))
    ) {
      try {
        setLoading(true);
        dispatch(contactUs(formData, navigate));
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
  };

  return (
    <Container>
      <div className="ellipse--container">
        <img src={ellipse} alt="Ellipse" />
        <h3>Get in touch with us .</h3>
      </div>
      <div className="row--container">
        <div className="col--1">
          <form
          name="contact"
           onSubmit={(e) => {
            e.preventDefault()
            handleSubmit()
          }}  
          >
            <InputGroup
              label="Full name"
              placeholder={"Enter your full name"}
              value={formData.name}
              name="name"
              onChange={handleInput}
            />
            <InputGroup
              type="email"
              label="Email address"
              placeholder={"Enter your email address"}
              value={formData.email}
              name="email"
              onChange={handleInput}
            />
            <InputGroup
              type="tel"
              label="Phone number"
              placeholder={"Enter your phone number"}
              name="phone_number"
            />
            <InputGroup>
              <label>Request</label>
              <textarea
                placeholder={"State your issue, or enquiry"}
                value={formData.message}
                onChange={handleInput}
                name="message"
              />
            </InputGroup>
            <Button type="submit">Submit</Button>
          </form>
        </div>
        <div className="col--2">
          <div>
            <h3>Telephone</h3>
            <p>
              <a href="tel:+234 7014747655">+234 7014747655</a>
            </p>
            <p>
              <a href="tel:+234 7014747655">+234 7014747655</a>
            </p>
          </div>

          <div>
            <h3>Email address</h3>
            <p>
              <a href="mailto:hello@pickorder.com">hello@pickorder.com</a>
            </p>
          </div>

          <div>
            <h3>Address</h3>
            <p>
              (504) 271-0921
              <br />
              3712 Chalona Dr
              <br />
              Chalmette, Louisiana(LA), 70043
            </p>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default GetInTouch;
